import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import i18next from 'i18next';
import { saveAs } from 'file-saver';

import { DataEntryService } from 'src/app/core/services/data-entry.service';
import { I18NextModule } from 'angular-i18next';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
@Component({
  standalone: true,
  selector: 'app-documentation-info',
  templateUrl: './documentation-info.component.html',
  styleUrls: ['./documentation-info.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    RouterModule,
    MatTableModule,
    MatTooltipModule,
    MatIconModule
  ]
})
export class DocumentationInfoComponent implements OnInit {
  group!: string;
  groupTranslation = '';
  documentsResponse!: string[];
  documents: any[] = [];
  displayedColumns: string[] = ['documentName', 'download'];

  constructor(
    private route: ActivatedRoute,
    private dataEntryService: DataEntryService
  ) {}

  ngOnInit(): void {
    this.route.queryParams?.subscribe((params) => {
      const group = params['group'];
      if (!!group) {
        this.group = group;
        this.dataEntryService.getPublicDocumentation(this.group).subscribe({
          next: (resp: string[]) => {
            this.documentsResponse = resp;
            this.documents = [];
            this.documentsResponse.forEach((document: string) => {
              const documentation = document.split('/').pop();
              if (documentation) {
                this.documents.push({
                  name: documentation,
                  fullPath: document
                });
              }
            });
            this.group === 'VDAF'
              ? (this.groupTranslation = i18next.t('vdaf'))
              : (this.groupTranslation = i18next.t('vppsg'));
          }
        });
      }
    });
  }

  showDocument(document: string) {
    const documentName = `${this.group}/${document}`;
    const documentKey = {
      documentKey: documentName,
      group: this.group
    };
    this.dataEntryService.viewPublicDocument(documentKey).subscribe({
      next: (resp: any) => {
        const blob = new Blob([resp], { type: 'application/pdf' });
        saveAs(blob, documentName);
      }
    });
  }
}
